// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: icon('ic_user'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  list: icon('items_list'),
  accountPlus: icon('account_plus'),
  accountCheck: icon('account_check'),
  itemCheck: icon('item_check'),
  chart: icon('chart'),
  users: icon('users'),
  settings: icon('settings'),
  api: icon('api-rounded'),
  chart2: icon('chart2'),
  chart3: icon('chart3'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: { title: '' },
    items: [{ title: 'Dashboard', path: PATH_DASHBOARD.main, icon: ICONS.dashboard }],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: { title: 'Reports', roles: ['sysAdmin', 'accManager'] },
    items: [
      { title: 'Report', path: PATH_DASHBOARD.report, icon: ICONS.analytics },
      {
        title: 'Requests Report',
        path: PATH_DASHBOARD.reportRequests,
        icon: ICONS.chart,
        roles: ['sysAdmin', 'accManager'],
      },
      /*     {
        title: 'Feed Rate Report',
        path: PATH_DASHBOARD.reportFeedRate,
        icon: ICONS.chart2,
        roles: ['sysAdmin', 'accManager'],
      },
      {
        title: 'Click Rate Report',
        path: PATH_DASHBOARD.reportClickRate,
        icon: ICONS.chart3,
        roles: ['sysAdmin', 'accManager'],
      }, */
    ],
  },

  {
    subheader: { title: '' },
    items: [
      {
        title: 'Sites',
        path: PATH_DASHBOARD.sites.list('me'),
        icon: ICONS.list,
        roles: ['pubManager'],
      },
      {
        title: 'Campaigns',
        path: PATH_DASHBOARD.campaigns.list('me'),
        icon: ICONS.list,
        roles: ['advManager'],
      },
      {
        title: 'Finance',
        path: PATH_DASHBOARD.finance,
        icon: ICONS.list,
        roles: ['advManager', 'pubManager'],
      },
    ],
  },

  {
    subheader: { title: 'Publishers', roles: ['sysAdmin', 'accManager'] },
    items: [
      {
        title: 'Sites',
        path: PATH_DASHBOARD.sitesAll,
        icon: ICONS.list,
        roles: ['sysAdmin'],
      },
      {
        title: 'Publishers',
        path: PATH_DASHBOARD.publishers.list,
        icon: ICONS.list,
        roles: ['sysAdmin', 'accManager'],
      },
      {
        title: 'Create Publisher',
        path: PATH_DASHBOARD.publishers.new,
        icon: ICONS.accountPlus,
        roles: ['sysAdmin'],
      },
      {
        title: 'Pending Publishers',
        path: PATH_DASHBOARD.audit('publishers'),
        icon: ICONS.accountCheck,
        roles: ['sysAdmin'],
      },
      {
        title: 'Pending Sites',
        path: PATH_DASHBOARD.audit('sites'),
        icon: ICONS.itemCheck,
        roles: ['sysAdmin'],
      },
    ],
  },

  {
    subheader: { title: 'Advertisers', roles: ['sysAdmin', 'accManager'] },
    items: [
      {
        title: 'Campaigns',
        path: PATH_DASHBOARD.campaignsAll,
        icon: ICONS.list,
        roles: ['sysAdmin'],
      },
      {
        title: 'Advertisers',
        path: PATH_DASHBOARD.advertisers.list,
        icon: ICONS.list,
        roles: ['sysAdmin', 'accManager'],
      },
      {
        title: 'Create Advertiser',
        path: PATH_DASHBOARD.advertisers.new,
        icon: ICONS.accountPlus,
        roles: ['sysAdmin'],
      },
      {
        title: 'Pending Advertisers',
        path: PATH_DASHBOARD.audit('advertisers'),
        icon: ICONS.accountCheck,
        roles: ['sysAdmin'],
      },
      {
        title: 'Pending Campaigns',
        path: PATH_DASHBOARD.audit('campaigns'),
        icon: ICONS.itemCheck,
        roles: ['sysAdmin'],
      },
    ],
  },

  {
    subheader: { title: 'Platform', roles: ['sysAdmin', 'pubManager', 'advManager'] },
    items: [
      { title: 'Users', path: PATH_DASHBOARD.users.list, icon: ICONS.users, roles: ['sysAdmin'] },
      {
        title: 'Settings',
        path: PATH_DASHBOARD.settings,
        icon: ICONS.settings,
        roles: ['sysAdmin'],
      },
      {
        title: 'API Docs',
        path: PATH_DASHBOARD.api,
        icon: ICONS.api,
        roles: ['pubManager', 'advManager'],
      },
    ],
  },
];

export default navConfig;
